/**
 * @module cercaliagl/LonLat
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import maplibregl from 'maplibre-gl';
import { transform } from 'ol/proj';
import BaseObject from './BaseObject';
import Proj from './proj';
/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const lonLat = new cercaliagl.LonLat(1.4151455, 41.24514);
 * ```
 * <br/>
 *
 * Coordinates. Let you specify the coordinates in EPSG:4326 projection<br/>
 * More information about this projection: https://epsg.io/4326
 *
 * @api
 */
var LonLat = /** @class */ (function (_super) {
    __extends(LonLat, _super);
    /**
     * @constructor
     * @param {number|string} lon Longitude, in geographic coordinate system
     * @param {number|string} lat Latitude, in geographic coordinate system
     */
    function LonLat(lon, lat, srs) {
        if (srs === void 0) { srs = Proj.EPSG4326; }
        var _this = _super.call(this) || this;
        var transformedCoords = srs === Proj.EPSG3857 ? transform([Number(lon), Number(lat)], Proj.EPSG3857, Proj.EPSG4326) : [Number(lon), Number(lat)];
        /**
         * @private
         * @type {number}
         */
        // eslint-disable-next-line prefer-destructuring
        _this.lon_ = transformedCoords[0];
        /**
         * @private
         * @type {number}
         */
        // eslint-disable-next-line prefer-destructuring
        _this.lat_ = transformedCoords[1];
        return _this;
    }
    /**
     * @param {import('maplibre-gl/src/geo/lng_lat').default} lonLat Lon lat
     */
    LonLat.fromMapboxgl = function (lonLat) {
        return new LonLat(lonLat.lng, lonLat.lat);
    };
    /**
     * @param {import("./util").GeometryGeoJSON} [geometry] GeoJSON Geometry. Use that or `wkt` property.
     */
    LonLat.fromGeometry = function (geometry) {
        return new LonLat(geometry.coordinates[0], geometry.coordinates[1]);
    };
    /**
     * Obtain longitude coordinate
     * @return {number} Coordinate Longitude
     * @api
     */
    LonLat.prototype.getLon = function () {
        return this.lon_;
    };
    /**
     * Obtain latitude coordinate
     * @return {number} Latitud
     * @api
     */
    LonLat.prototype.getLat = function () {
        return this.lat_;
    };
    /**
     * @return {LngLat}
     */
    LonLat.prototype.toMapboxLngLat = function () {
        return new maplibregl.LngLat(this.lon_, this.lat_);
    };
    /**
     * Position to string. Format `longitude,latitude`.
     * @return {string} To string longitude,latitude. For example: `"1.41651,41.541451"
     * @override
     * @api
     */
    LonLat.prototype.toString = function () {
        return "".concat(this.lon_, ",").concat(this.lat_);
    };
    /**
     * Transform position to array `[longitude, latitude]`.
     * @api
     * @return {Array.<number>}
     */
    LonLat.prototype.toArray = function () {
        return [this.lon_, this.lat_];
    };
    return LonLat;
}(BaseObject));
export default LonLat;
//# sourceMappingURL=LonLat.js.map